import React, { forwardRef, useId } from "react";

const base = [
    "block w-full",
    "rounded",
    "border border-gray-100 dark:border-white/10",
    "bg-gray-50 dark:bg-white/5",
    "text-xs font-normal text-foreground-light dark:text-foreground-dark",
    "placeholder:font-normal placeholder:text-gray-400 dark:placeholder:text-neutral-500",
    "focus:bg-white dark:focus:bg-card-dark",
    "focus:outline-none focus:ring-0 focus:border-primary",
    "transition-all duration-150 ease-in-out",
    "px-3 py-2",
].join(" ");

const helper = "text-xs leading-relaxed";
const cx = (...c) => c.filter(Boolean).join(" ");

const Textarea = forwardRef(function Textarea(
    {
        id,
        label,          // opcional
        hint,           // opcional
        error,          // opcional
        className = "",
        labelClassName = "",
        required,
        rows = 4,
        ...props
    },
    ref
) {
    const uid = useId(); // 👈 SIEMPRE se llama
    const inputId = id ?? `textarea-${uid}`;
    const hintId = `hint-${uid}`;
    const errorId = `error-${uid}`;

    const describedBy =
        [error ? errorId : null, hint ? hintId : null].filter(Boolean).join(" ") ||
        undefined;

    return (
        <div className="space-y-1.5">
            {label && (
                <label
                    htmlFor={inputId}
                    className={cx("block text-xs sm:text-sm font-normal text-foreground-light dark:text-foreground-dark", labelClassName)}
                >
                    {label}{" "}
                    {required && (
                        <span className="text-danger-light dark:text-danger-dark">*</span>
                    )}
                </label>
            )}

            <textarea
                id={inputId}
                ref={ref}
                rows={rows}
                aria-invalid={!!error}
                aria-describedby={describedBy}
                className={[
                    base,
                    className,
                    error ? "ring-1 ring-danger-light dark:ring-danger-dark" : "",
                ].join(" ")}
                {...props}
            />

            {error ? (
                <p id={errorId} className={`${helper} text-danger-light dark:text-danger-dark`}>
                    {error}
                </p>
            ) : hint ? (
                <p id={hintId} className={`${helper} text-subtle-light dark:text-subtle-dark`}>
                    {hint}
                </p>
            ) : null}
        </div>
    );
});

export default Textarea;